export default "__VITE_ASSET__B1FWMVX2__"